(ns machtfit.stepchall.alert-bar
  (:require [machtfit.stepchall.countdown :as countdown]
            [machtfit.stepchall.icons :as icons]
            [machtfit.stepchall.subs :as subs]
            [machtfit.storage :as-alias storage]
            [machtfit.translation :refer [tr t tr-with-place-holders replace-place-holders]]
            [machtfit.utils :as utils]
            [re-frame.core :as rf]))

(def ^:private alerts
  {:challenge-starts-in {:message "Noch {countdown} bis zum Start {the-challenge-genitive}."
                         :count-down-to :challenge-start}
   :challenge-already-started {:message "{The-challenge} läuft bereits. Du hast noch {countdown} Zeit um einem Team beizutreten."
                               :count-down-to :team-building-end}
   :team-building-over {:message "Der Anmeldezeitraum ist leider vorbei. Du kannst {the-challenge-accusative} nun als Zuschauer verfolgen."}
   :challenge-ends-in {:message "{The-challenge} endet in {countdown-dative}."
                       :count-down-to :challenge-end}
   :challenge-ended-record-steps {:message "{The-challenge} ist beendet. Du kannst noch {countdown} deine {main-units} der letzten Tage eintragen."
                                  :count-down-to :recording-end}
   :challenge-ended-feedback {:message "{The-challenge} ist vorbei. Wir freuen uns über Feedback."}
   :challenge-ended-no-feedback {:message "{The-challenge} ist vorbei."}})

(defn restore-from-local-storage [db local-storage]
  (let [key 'machtfit.app.stepchall.spectator-alert-dismissed?
        value (get local-storage key #{})]
    (assoc-in db [:ui :stepchall :flag-spectator-alert-dismissed?] value)))

(rf/reg-sub ::spectator-alert-dismissed?
  :<- [:get [:stepchall :id]]
  :<- [:get [:ui :stepchall :flag-spectator-alert-dismissed?]]

  (fn [[stepchall-id alerts-dismissed] _]
    (utils/in? alerts-dismissed stepchall-id)))

(rf/reg-sub ::alert-key
  :<- [:get [:clock :current-server-time]]
  :<- [:get [:stepchall :challenge-start]]
  :<- [:get [:stepchall :challenge-end]]
  :<- [:get [:stepchall :team-building-end]]
  :<- [:get [:stepchall :recording-end]]
  :<- [::subs/is-team-member?]
  :<- [::spectator-alert-dismissed?]
  :<- [:get [:stepchall :feedback-url]]

  (fn [[current-time challenge-start challenge-end team-building-end recording-end is-team-member? spectator-alert-dismissed? feedback-url] _]
    (let [before-start? (< current-time challenge-start)
          in-challenge-phase? (and (not before-start?)
                                   (< current-time challenge-end))
          spectator? (not is-team-member?)
          in-team-building-phase? (< current-time team-building-end)
          in-recording-phase? (< current-time recording-end)]
      (cond
        before-start? :challenge-starts-in
        (and spectator? in-team-building-phase?) :challenge-already-started
        (and in-challenge-phase? spectator?
             (not spectator-alert-dismissed?)) :team-building-over
        in-challenge-phase? :challenge-ends-in
        (and is-team-member? in-recording-phase?) :challenge-ended-record-steps
        feedback-url :challenge-ended-feedback
        :else :challenge-ended-no-feedback))))

(rf/reg-event-fx ::alert-spectator-close-clicked
  (fn [{:keys [db]} _]
    (let [stepchall-id (-> db :stepchall :id)
          alerts-dismissed (-> db :ui :stepchall :flag-spectator-alert-dismissed?
                               (conj stepchall-id))]
      {:db (assoc-in db [:ui :stepchall :flag-spectator-alert-dismissed?] alerts-dismissed)
       ::storage/local-storage-put {'machtfit.app.stepchall.spectator-alert-dismissed? alerts-dismissed}})))

(defn alert-bar []
  (let [stepchall @(rf/subscribe [:get [:stepchall]])
        current-time @(rf/subscribe [:get [:clock :current-server-time]])
        alert-key @(rf/subscribe [::alert-key])
        {:keys [message count-down-to]} (alerts alert-key)
        target-time (get stepchall count-down-to 0)
        names @(rf/subscribe [:get [:stepchall :names]])
        feedback-url (when (= alert-key :challenge-ended-feedback) @(rf/subscribe [:get [:stepchall :feedback-url]]))
        main-unit-plural @(rf/subscribe [:get [:stepchall :main-unit :plural]])]
    [:div.sc_alert-bar
     [:div.sc_vertical-center.sc_justify-space
      [:div.sc_alert-bar-message (tr-with-place-holders
                                  message
                                  {"countdown" (countdown/countdown {:from current-time
                                                                     :until target-time})
                                   "countdown-dative" (countdown/countdown {:from current-time
                                                                            :until target-time
                                                                            :dative? true})
                                   "the-challenge-genitive" (t (:the-challenge-genitive names))
                                   "the-challenge" (t (:the-challenge names))
                                   "the-challenge-accusative" (t (:the-challenge-accusative names))
                                   "main-units" (t main-unit-plural)})]
      (when feedback-url
        [:a.sc_btn.sc_btn-primary {:href (replace-place-holders feedback-url {"customer-number" @(rf/subscribe [:get [:user :customer-number]])
                                                                              "subdomain" @(rf/subscribe [:get [:subdomain]])
                                                                              "challenge-id" @(rf/subscribe [:get [:stepchall :id]])})
                                   :target "_blank"}
         [:i.sc_icon [icons/like]] (tr "Feedback geben")])
      (when (= alert-key :team-building-over)
        [:button {:on-click #(rf/dispatch [::alert-spectator-close-clicked])} [icons/close]])]]))
